import Icon from '@/common/components/Icon';

const { default: styled } = require('styled-components');

export const Wrapper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(2, 80, 114, 0.78);
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const Window = styled.div`
	background-color: #fff;
	position: relative;
	padding: 2rem 5rem;
`;

export const Form = styled.form`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 1rem;
	margin-top: 1rem;
`;

export const CloseButton = styled(Icon)`
	position: absolute;
	top: 15px;
	right: 20px;
	color: red;
	cursor: pointer;
`;

export const SubmitButton = styled.input`
	padding: 0.5rem 1rem;
`;

export const InputField = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const Select = styled.select`
	border-radius: 10px;
	padding: 5px 5px 5px 15px;
	border: 1px solid lightgray;
`;
